import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import classcat from "classcat";
import { translate as t } from "../../translate/localization";
import alternateCountryTranslations from "../../translate/alternateCountyTranslations/index";
import Modal from "../../../app/components/modals/Modal";
import CobeeButton from "../../../app/components/CobeeButton";
import CobeeCheckbox from "../../../app/components/CobeeCheckbox";
import childcareImg from "../../../assets/img/childcare.svg";
import useStyles from "./styles";

export default function AdvanceNurseryModal({ benefit, country, callback }) {
  const [benefitDisabled, setIsBenefitDisabled] = useState(
    benefit?.disabledFlex["nursery-benefit"] || false
  );
  const {
    container,
    imageStyles,
    titleStyles,
    row,
    settingsText,
    checkboxContainer,
    checkboxText,
    descriptionText,
  } = useStyles();

  return (
    <Modal>
      <Grid className={container}>
        <Grid container xs={12} item alignItems="flex-end">
          <img
            src={childcareImg}
            alt="nursery-modal-img"
            className={imageStyles}
          />
          <Typography variant="h4" className={titleStyles}>
            {t("benefits-section.nursery-benefit.nursery")}
          </Typography>
        </Grid>

        <Typography variant="body2" className={row}>
          {alternateCountryTranslations(
            country,
            "nursery-advanced-config-description"
          )}
        </Typography>
        <Typography variant="h6" className={classcat([row, settingsText])}>
          {t("common-messages.adjustments")}
        </Typography>
        <Grid
          container
          alignItems="center"
          onClick={() => setIsBenefitDisabled((prev) => !prev)}
        >
          <CobeeCheckbox
            className={checkboxContainer}
            checked={benefitDisabled}
          />
          <Typography variant="body2" className={checkboxText}>
            {t("benefits-section.nursery-benefit.nursery-check-text")}
          </Typography>
        </Grid>
        <Typography variant="body2" className={descriptionText}>
          {t(
            "benefits-section.nursery-benefit.nursery-advanced-config-check-description"
          )}
        </Typography>
        <Grid item container xs={12} justify="center" className={row}>
          <CobeeButton
            onClick={() =>
              callback({
                ...benefit,
                disabledFlex: {
                  ...benefit.disabledFlex,
                  "nursery-benefit": benefitDisabled,
                },
              })
            }
          >
            {t("actions.save")}
          </CobeeButton>
        </Grid>
      </Grid>
    </Modal>
  );
}

AdvanceNurseryModal.propTypes = {
  benefit: PropTypes.object,
  country: PropTypes.string,
  callback: PropTypes.func,
};

AdvanceNurseryModal.defaultProps = {
  benefit: {},
  country: "ES",
  callback: () => {},
};
